<template>
    <div class="container">
        <div class="introduce">
            自定义项目类型
        </div>
        <div class="tableContainer">
            <el-form size="mini" class="">
                <el-checkbox-group 
                    v-model="checkedProject">
                    <el-checkbox 
                     v-for="item in projects" 
                     :label="item" 
                     :key="item"
                     :disabled="enabled"
                     style="display: block;">
                    <p style="padding-top: 10px">
                        {{item}}
                    </p> 
                    </el-checkbox>
                </el-checkbox-group>
              </el-form>
        </div>
            <el-button class="btn" :disabled="enabled" type="primary" plain  @click="save">保存</el-button>
    </div>
</template>

<script>
        const projectOptions = ['(GX)共享促销员','(SP)店内短促','(RS)路演','(ST)店内长促','(GA)GA共享促销员',
    '(GS)GS共享促销员','(MM)物料制作','(PR)会务/会展','(DS)派样','(SE)店内活动','(SM)销售管理','(TS)技术服务','(PP)PP店内短促','(CA)费用代垫'];
export default {

    data() {
        return {
            auths:[],
            projects:[],
            checkedProject:[],
            // checkedProject:[ "(RS)路演", "(SP)店内短促", "(GX)共享促销员", "(GS)GS共享促销员", "(MM)物料制作" ],
            enabled:false,
        };
    },

    mounted() {
        this.getAuth();
        this.$http({
            method:"GET",
            url:"/rest/projectCategory/init"
        }).then(res=>{
            console.log(res.data.data);
            res.data.data.map(item=>{
              let porjectTypeName = item.porjectTypeName!=null?item.porjectTypeName:"--";
                this.projects.push("("+item.porjectType+")"+porjectTypeName);
            })
            
        })

        this.$http({
            method:"GET",
            url:"/rest/projectCategory/list"
        }).then(res=>{
            console.log(res.data.data);
            res.data.data.map(item=>{
                this.checkedProject.push(item.categoryName)
            })
        })

    },

    methods: {
        getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 45,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          res.data.map(item => {
            this.auths.push(item.auth)
          })
          if(this.auths[0]<2){
            this.enabled=true
        }
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
       
      },
      handleSelectionChange(val) {
        this.projects = val;
      },
      // toggleSelection(rows) {
      //   if (rows) {
      //     rows.forEach(row => {
      //       this.$refs.multipleTable.toggleRowSelection(row);
      //     });
      //   } else {
      //     this.$refs.multipleTable.clearSelection();
      //   }
      // },
      save() {
        this.$http({
          method: "POST",
          url: "/rest/projectCategory/save",
          data:this.checkedProject
        }).then(res => {
           this.$router.go(0)
        }).catch(err => {
        //   utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
    },
};
</script>

<style lang="scss" scoped>

.container {
    background: #fff;
    height: 100%;
    padding: 10px;
    line-height: 30px;
}
.introduce {
    transform: translate(14%,60%);
    font-size: 15px;
    font-weight: 400;
    height: 5%;
}
.tableContainer{
    padding: 10px 10px;
    transform: translate(85%,6%);
    border: 1px solid black;
    overflow: scroll;
    height: 70%;
    width: 15%;
}
.btn{
    width: 10%;
    /* display: flex; */
    transform: translate(172%,180%);

}
</style>


// WEBPACK FOOTER //
// src/views/personnelCenter/projectCategory.vue